import { PropsWithChildren } from 'react';

export function FullWidthContent({ children }: PropsWithChildren<{}>) {
  return <div className="flex items-center">{children}</div>;
}
